import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BlockRefreshingGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const redirectUrl = route.data.redirectUrl;
    const nav = this.router.getCurrentNavigation();

    if (nav.id === 1 && nav.previousNavigation === null) {
      this.router.navigate([redirectUrl]);
    } else {
      return true;
    }
  }
}
